import React, { useState } from "react";
import { chooseOptionBuro } from "./ChooseOptionBuro.css";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import {
  buroPersonaF,
  buroPersonaFE,
  buroPersonaM,
} from "../../../../Assets/Images";

export const ChooseOptionBuro = ({ setPageStep3 }) => {
  const navigateTo = useNavigate();
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const persons = [
    {
      img: buroPersonaFE,
      type: 1,
      title: 'Soy persona física con actividad empresarial (PFAE).',
      description: 'Soy independiente o empresario con ingresos facturados a mi nombre.',
      disabled: false,
      requirements: [
        'Nombre completo',
        'RFC con homoclave',
        'Clave CIEC (es seguro y no se compartira)',
        'Teléfono',
        'Correo electrónico',
        'Dirección',
        'Identificación oficial (INE / IFE y/o firma migratoria / pasaporte)',
        'Comprobante de domicilio',
        'Últimos 6 estados de cuenta bancarios',
        '3 referencias personales (nombre, teléfono y relación)',
      ]
    },
    {
      img: buroPersonaF,
      type: 3,
      title: 'Soy persona física (PF).',
      description: 'Mis ingresos provienen mayormente de nómina o pensión.',
      disabled: false,
      requirements: [
        'Nombre completo',
        'RFC con homoclave',
        'Teléfono',
        'Correo electrónico',
        'Dirección',
        'Identificación oficial (INE / IFE y/o firma migratoria / pasaporte)',
        'Comprobante de domicilio',
        'Últimos 6 estados de cuenta bancarios',
        '3 referencias personales (nombre, teléfono y relación)',
      ]
    },
    {
      img: buroPersonaM,
      type: 2,
      title: 'Soy persona moral.',
      description: 'Mis ingresos provienen mayormente de la emisión de facturas.',
      disabled: false,
      requirements: [
        'RFC de la empresa y del representante',
        'Nombre de la empresa y del representante',
        'Teléfono de la empresa y del representante',
        'Correo electrónico de la empresa y del representante',
        'Dirección de la empresa',
        'Identificación oficial (INE / IFE y/o firma migratoria / pasaporte)',
        'Comprobante de domicilio de la empresa y del representante',
        'Últimos 3 estados de cuenta bancarios de la empresa',
        'Acta constitutiva',
        'Poder notarial',
        'Comprobante de domicilio del representante',
        'Últimos 3 estados de cuenta bancarios del representante',
        'clave CIEC (es seguro y no se compartira)',
      ]
    }
  ];


  const handleSelect = (type) => {
    setPageStep3(prev => ({
      ...prev,
      selectedMethod: 2,
      selectedTypePerson: type
    }));
  };

  return (
    <div css={chooseOptionBuro()}>
      <section className="ButtonSection2">
        <div className="TopText">
          Comienza tu Solicitud de Crédito
          <br />
        </div>
        <div className="TextContainer">
          {/* <span>Compártenos tus datos </span>
          <br /> */}
          <span>¿Cómo quieres continuar tu proceso?</span>
          <span className="NormalMedium font-normal">Selecciona una opción</span>
        </div>

        <div className="PersonsContainer">
          <TransitionGroup component="div" className="PersonsGrid">
            {persons.map((person, index) => {
              const isSelected = false; // No hay selección en este componente
              const isHovered = hoveredIndex === index;

              return (
                <CSSTransition
                  key={person.type}
                  timeout={300}
                  classNames="person-transition"
                >
                  <div
                    className={`PersonCard ${person.disabled ? "disabled" : ""
                      }`}
                    style={{
                      transform: isHovered && !person.disabled ? "scale(1.05)" : "scale(1)",
                      boxShadow: isHovered && !person.disabled ? "0px 4px 10px rgba(0, 0, 0, 0.2)" : "none",
                    }}
                    onClick={() => !person.disabled && handleSelect(person.type)}
                    onMouseEnter={() => !person.disabled && setHoveredIndex(index)}
                    onMouseLeave={() => !person.disabled && setHoveredIndex(null)}
                  >
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                      <img
                        src={person.img}
                        className="PersonImg"
                        alt={person.title}
                      />
                      <div className="PersonTitle">
                        {person.title}
                      </div>
                      <div className="PersonDescription">
                        {person.description}
                      </div>
                    </div>

                    <div className="RequirementsContainer">
                      <div className="RequirementsTitle">
                        Recuerda tener a la mano:
                      </div>
                      <ul className={`RequirementsList ${person.type === 2 ? "TwoColumns" : ""}`}>
                        {person.requirements.map((req, idx) => (
                          <li
                            className="RequirementItem"
                            key={idx}>
                            {req}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </CSSTransition>
              );
            })}
          </TransitionGroup>
          <br />
          <div className="Shadow"></div>
          <br />

        </div>

        {/* <div className="ButtonWithShadow">
          <Button
            label="Estoy listo"
            className="Green py-3 mt-4"
            onClick={() => navigateTo("/cotizador/step3")}
          />
          <div className="Shadow"></div>
        </div> */}
      </section>
    </div>
  );
};
